import createConditionCatalog from '@/helpers/createConditionCatalog';

export default createConditionCatalog([
  {
    name: 'member',
    label: 'member',
    value: null,
  },
  {
    name: 'not_member',
    label: 'not member',
    value: null,
  },
]);
